namespace TabAurous.Stock {
    export namespace StoneStockService {
        export const baseUrl = 'Stock/StoneStockforSorting';

        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StoneStockforSorting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>StoneStockService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
